var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenue24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M6.63 11.12h1.32c.22-2.87 1.84-4.87 4.98-4.87 1.07 0 1.78.18 2.25.36l.24 1.61h-.08c-.58-.2-1.26-.4-2.35-.4-2.06 0-2.88 1.18-3.02 3.3h4.05v1.28H9.97c.12 2.06.94 3.28 3.1 3.28 1.06 0 1.75-.21 2.37-.43h.06l-.2 1.61c-.53.21-1.42.39-2.3.39-3.35 0-4.88-2.06-5.07-4.85H6.5l.13-1.28Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "stroke",
    cx: 12,
    cy: 12,
    r: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue24);
export default __webpack_public_path__ + "static/media/revenue_24.276e36b2ed9cf9fc7182f023d95ed069.svg";
export { ForwardRef as ReactComponent };